import React, { Component } from 'react';

class Icon extends Component {
  render() {
    const { onAction, width, height } = this.props;

    return (
      <div>
        { this.props.children(onAction, width, height) }
      </div>
    );
  }
}

export default (Icon);



// WEBPACK FOOTER //
// ./src/components/icons/Icon.jsx